import i18n from './config';

export function t(key: string, options?: Record<string, unknown>): string {
  return i18n.t(key, options);
}

export function tList(key: string): string[] {
  const value = i18n.t(key, { returnObjects: true });
  return Array.isArray(value) ? value.map(String) : [];
}
